import type { ComponentType, PropsWithChildren } from 'react';
import type React from 'react';

import { TrackingContext } from '@change-corgi/core/react/tracking';

import type { ErrorStateDetails } from 'src/app/shared/utils/async';
import { isError, isLoaded } from 'src/app/shared/utils/async';

import type { PetitionGuidesPageCombinedState, PetitionGuidesPagePrefetchedContext } from './hook';
import { usePageContext } from './hook';
import { PetitionGuidesPageDataContextProvider } from './pageData';

export type ErrorHandlerProps = { context: ErrorStateDetails<PetitionGuidesPageCombinedState> };

type Props = {
	slug: string;
	prefetchedData: PetitionGuidesPagePrefetchedContext | undefined;
	errorHandler: ComponentType<ErrorHandlerProps>;
	loadingFallback: JSX.Element;
};

export const PetitionGuidesPageContextProvider: React.FC<PropsWithChildren<Props>> = ({
	children,
	slug,
	prefetchedData,
	errorHandler: ErrorHandler,
	loadingFallback,
}) => {
	const pageContextState = usePageContext(slug, prefetchedData);

	if (isError(pageContextState)) {
		const { status, ...rest } = pageContextState;
		return <ErrorHandler context={rest} />;
	}
	if (!isLoaded(pageContextState)) return loadingFallback;

	const { pageData } = pageContextState;

	return (
		<PetitionGuidesPageDataContextProvider pageData={pageData}>
			<TrackingContext properties={{ article_id: pageData.data.article.slug }}>{children}</TrackingContext>
		</PetitionGuidesPageDataContextProvider>
	);
};
